document.addEventListener('DOMContentLoaded', function (event) {
  var $ = jQuery

  /* Promo bar */
  var promo = document.querySelector('.js-promo-bar') || false;
  var promoIsClosed = Cookies.get('promo_closed') || false;

  if (promo) {
    if (!promoIsClosed) {
      var closeBtn = promo.querySelector('.js-promo-bar-close') || false;

      promo.style.opacity = '1';

      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          promo.classList.add('static-promo--closed');
          Cookies.set('promo_closed', true);
        });
      }
    } else {
      promo.style.display = 'none';
    }
  }

  /**
   * Quantity module
  **/

  function Quantity (el) {
    var UP_SELECTOR = '.js-increase'
    var DOWN_SELECTOR = '.js-decrease'
    var INPUT_SELECTOR = '.js-input'
    var input = el.querySelector(INPUT_SELECTOR)
    var minLimit = input.getAttribute('min') ? parseInt(input.getAttribute('min')) : 0
    var upEl = el.querySelector(UP_SELECTOR)
    var downEl = el.querySelector(DOWN_SELECTOR)

    if (upEl) {
      upEl.addEventListener('click', function (event) {
        event.preventDefault()
        input.value++
        $(input).trigger('change') // Add event
      })
    }
    if (downEl) {
      downEl.addEventListener('click', function (event) {
        event.preventDefault()
        input.value = Math.max(minLimit, input.value - 1)
        $(input).trigger('change') // Add event
      })
    }
  }

  var quantityModules = Array.prototype.slice.call(document.querySelectorAll('[data-module-init="quantity"]')) || false
  if (quantityModules) {
    quantityModules.map(function (module) { return new Quantity(module) })
  }

  /**
   * Mix and Match Cart
   */

  function MixCart (el) {
    var MIN_CART = 995
    var EPSILON = 0.01 // Allowable floating point error
    var qtyEl = el.querySelector('.js-cart-number')
    var subTotalEl = el.querySelector('.js-cart-subtotal')
    var qtyItems = Array.prototype.slice.call(el.querySelectorAll('[data-cart-trigger]'))
    var button = el.querySelector('.js-submit')
    var DISABLED_CLASS = 'product-grid-mix--disabled'
    var cartTotalPrice = parseInt(document.querySelector('[data-header-cart-total-price]').getAttribute('data-header-cart-total-price'))
    var data = []
    qtyItems.forEach(function (input, index) {
      var itemQty = parseInt(input.value)
      var variantId = parseInt(input.id)
      var itemPrice = parseFloat(input.getAttribute('price')).toFixed(2)
      var itemData = {
        'variant': variantId,
        'qty': itemQty,
        'price': itemPrice
      }
      data.push(itemData)
      $(input).on('change', function () {
        var currentValue = $(this).val()
        data[index]['qty'] = parseInt(currentValue)
        if (qtyEl) {
          updateTotalItems()
        }
        if (subTotalEl) {
          updateSubTotalMoney()
        }
        if (button) {
          maybeButtonVisible()
        }
      })
    })

    var addToCart = function(id, qty) {
      var d = $.Deferred()
      CartJS.addItem(id, qty, {}, {
        'success': function() {
          d.resolve()
        },
        'error': function(jqXHR, textStatus, errorThrown) {
          console.error(errorThrown)
          d.reject()
        }
      })

      return d.promise()
    }

    /**
     * Button submit AJAX cart
     */
    if (button) {
      $(button).on('click', function (event) {
        event.preventDefault()
        var requests = []
        for (var i = 0; i < data.length; i++) {
          if (data[i]['qty'] > 0) {
            requests.push(addToCart(
              data[i]['variant'],
              data[i]['qty']
            ))
          }
        }

        $.when.apply($, requests).done(function() {
          window.location.href = button.getAttribute('href')
        })
      })
    }
    /**
     * Update total items
     */
    function updateTotalItems () {
      var count = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i]['qty'] > 0) {
          count = count + data[i]['qty']
        }
      }
      /**
       * Update a new value
       */
      qtyEl.innerHTML = count
    }

    /**
     * Update subtotal
     */
    function updateSubTotalMoney () {
      var subtotalCount = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i]['qty'] > 0) {
          subtotalCount += data[i]['qty'] * data[i]['price']
          subtotalCount = Number(subtotalCount.toFixed(2))
        }
      }
      subTotalEl.innerHTML = subtotalCount
    }

    /**
     * Check if can set button visible
     */
    function maybeButtonVisible () {
      var totalItem = parseInt(qtyEl.innerHTML)
      var mixCartTotalPrice = parseFloat(subTotalEl.innerHTML)
      var checkButtonVisible = false
      var totalPrice = cartTotalPrice + mixCartTotalPrice * 100 + EPSILON
      if ( totalItem > 0 && totalPrice >= MIN_CART ) {
        checkButtonVisible = true
      }
      checkButtonVisible ? el.classList.remove(DISABLED_CLASS) : el.classList.add(DISABLED_CLASS)
    }
  }

  var mixCartModules = Array.prototype.slice.call(document.querySelectorAll('[data-module-init="mix-cart"]')) || false
  if (mixCartModules) {
    mixCartModules.map(function (module) { return new MixCart(module) })
  }
})
